import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSortArrowUpDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sort-arrow-up-down"} maskId="square-filled-radius-0-stroke-1-IconSortArrowUpDown"><path d="M3 3V11H11V3H3Z" fill="currentColor"/><path d="M18 3.29289L13.7929 7.5L14.5 8.20711L17.5 5.20711V18.7929L14.5 15.7929L13.7929 16.5L18 20.7071L22.2071 16.5L21.5 15.7929L18.5 18.7929V5.20711L21.5 8.20711L22.2071 7.5L18 3.29289Z" fill="currentColor"/><path d="M3 13V21H11V13H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSortArrowUpDown;
